import React, { useEffect, useState } from "react";
import {SlDrawer } from '@shoelace-style/shoelace/dist/react';
import Select from "react-select";
import PreviewFrame from "../PreviewFrame";
import AnimationComponent from "./Animation";
import PromotedVideo from "./PromotedVideo";
import PromotedImage from "./PromotedImage";
import FullVideo from "./FullVideo";
import HalfVideo from "./HalfVideo";
import VideowithBg from "./VideowithBg";
import WebViewAd from "./WebViewAd";
import FullImage from "./FullImage";
import GalleryImage from "./GalleryImage";
import { Modal } from "react-bootstrap";
import "./modal.css";
import api from "../../services/api";
import PromotedGallery from "./PromotedGallery";
import CommentAd from "./CommentAd";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import BrandAdImage from "./BrandAdImage";
import NewsImage from "./NewsImage";
import NewsImageLogo from "./NewsImageLogo";
import NewsImageDesc from "./NewsImageDesc";
import VideoExpandable from "./VideoExpandable";
import VideoEndcard from "./VideoEndcard";
import VideoSkippable from "./VideoSkippable";
import BottomRectangle from "./BottomRectangle";
import RectangleClassified from "./RectangleClassified";
import SquareClassified from "./SquareClassified";
import FramePostComponent from "./FramePost";
import RecImage from "./RecImage";
import RecPromoted from "./RecPromoted";
// import { SlDrawer } from '@shoelace-style/shoelace/dist/react';


export const CreativeContext = React.createContext();

function CreativeCreation({ handleshow, editdata, flag, createdEdited }) {
  const [preview, setPreview] = useState({});

  const [selected, setSelected] = useState(editdata.creative_type || "");
  const [subType, setSubType] = useState(editdata.sub_type || "");

  const [fullImage, setFullImage] = useState(false);
  const [galleryImage, setGalleryImage] = useState(false);
  const [promotedVideo, setPromotedVideo] = useState(false);
  const [promotedImage, setPromotedImage] = useState(false);
  const [animation, setAnimation] = useState(false);
  const [fullvideo, setFullvideo] = useState(false);
  const [halfvideo, setHalfvideo] = useState(false);
  const [videowithbg, setVideowithbg] = useState(false);
  const [promotedgallery, setPromotedGallery] = useState(false);
  const [webviewad, setWebviewad] = useState(false)
  const [commentad, setCommentad] = useState(false)
  const [brandAdImage, setBrandAdImage] = useState(false)
  const [newsImageFlip, setNewsImageFlip] = useState(false)
  const [newsImageLogo, setNewsImageLogo] = useState(false)
  const [newsShortDesc, setNewsShortDesc] = useState(false)
  const [videoExpandable, setVideoExpandable] = useState(false)
  const [videoEndcard, setVideoEndcard] = useState(false)
  const [videoSkippable, setVideoSkippable] = useState(false)
  const [bottomRectangle, setBottomRectangle] = useState(false)
  const [square,setSquare] = useState(false)
  const [rectangle,setRectangle] = useState(false)
  const [framePost,setFramePost] = useState(false)
  const [recImages,setRecImages] = useState(false)
  const [recPromotedStory,setRecPromotedStory] = useState(false)

  const [submit, setSubmit] = useState(false);

  const handlesubmit = (value) => {
    setSubmit(value);
  };

  const [show, setShow] = useState(true);

  const handleModalClose = () => {
    setShow(!show);
    handleshow(false);
  };

  const changeSelectOptionHandler = (event) => {
    setSelected(event.value);
    setSubType(null);
  };
  const changeSubTypeHandler = (e) => {
    setSubType(e.value);
  };

  const [companyName, setCompanyName] = useState([]);
  const [company, setCompany] = useState("");
  const [advertiser, setAdvertiser] = useState([]);
  const [advId, setAdvId] = useState("");
  const [companyLabel, setCompanyLabel] = useState("");

  const loadCompany = async () => {
    try {
      const response = await api({
        url: `/creatives/image/companyname`,
        method: "GET",
        responseType: "json",
      });
      return response.data.result;
    } catch (error) {
      console.log("error");
    }
  };

  const loadId = async () => {
    let obj = { company };
    try {
      const response = await api({
        url: `/creatives/image/advIdName`,
        method: "POST",
        responseType: "json",
        data: obj,
      });
      return response.data.result;
    } catch (error) {
      console.log("error");
    }
  };

  const handleCompanyname = (e) => {
    setCompany(e.value);
    setCompanyLabel(e.label)
  };

  const handleAdvertiser = (e) => {
    setAdvId(e.value);
  };

  const [name, setName] = useState("");
  const handleCreativeName = (e) => {
    const nameregex = /^[A-Za-z0-9][A-Za-z0-9!@#$%^&*()_+-=<>?/|}{~:]*/
    const val = e.target.value
    if(val.match(nameregex)){
      setName(e.target.value);
    }
    else{
      setName("")
    }
  };

  useEffect(() => {
    (async () => {
      let a = await loadCompany();
      setCompanyName(a);
    })();
  }, []);

  // useEffect(() => {
  //   (async () => {
  //     let a = await loadId();
  //     setAdvertiser(a);
  //   })();
  // }, [company]);

  useEffect(() => {
    if (subType === "gallery")
      setPreview({ sub_type: subType, img_urls: [""] });
    else if (subType === "promoted_gallery")
      setPreview({ sub_type: subType, img_urls: [""] });
    else setPreview({ sub_type: subType });
  }, [subType]);

  const creativetype = {
    image: "Image",
    video: "Video",
    promotedStory: "Promoted Story",
    animation: "Animation",
  };
  const subtype = {
    full_image: "Full Image",
    gallery: "Gallery Image",
    full_video: "Full Video",
    half_video: "Half Video",
    video_with_bg: "Video with Background",
    promoted_image_story: "Promoted Image Story",
    promoted_video_story: "Promoted Video Story",
    promoted_gallery: "Promoted Gallery",
    fullvideo_or_gif: "Full Video or GIF",
    commentad: "Comment Ad"
  };

  const creativeType = [
    {
      value: "image",
      label: "Image",
    },
    {
      value: "video",
      label: "Video",
    },
    {
      value: "promotedStory",
      label: "Promoted Story",
    },
    // {
    //   value: "animation",
    //   label: "Animation",
    // },
    {
      value: "webviewad",
      label: "Web View Ad"
    },
    {
      value: "commentad"
      ,
      label:"Comment Ad"
    },
    {
      value:"brandad",
      label:"Brand Ad"
    },
    {
      value:"classifieds",
      label:"Classifieds"
    },
    {
      value:"framepost",
      label:"Frame Post"
    },
    {
      value: "recad",
      label: "Recommended Ads"
    }
  ];
  const Image = [
    { value: "full_image", label: "Full Image" },
    { value: "gallery", label: "Gallery Image" },
  ];
  const Video = [
    { value: "full_video", label: "Full Video" },
    { value: "half_video", label: "Half Video" },
    // { value: "video_with_bg", label: "Video with Background" },
  ];
  const PromotedStory = [
    { value: "promoted_image_story", label: "Promoted Image Story" },
    { value: "promoted_video_story", label: "Promoted Video Story" },
    { value: "promoted_gallery", label: "Promoted Gallery" },
  ];
  const Animation = [{ value: "fullvideo_or_gif", label: "Full Video or GIF" }];
  const webview = [{ value: "webviewad", label: "Web View Ad" }];
  const commentads = [{value: "commentad", label: "Comment Ad"}]
  const BrandAds = [
    // {value:"search", label:"Search"},
    // {value:"unread", label:"Unread"},
    {value:"news_image_flip", label:"News-Image Flip"},
    {value:"news_image_logo", label:"News-Image Logo"},
    // {value:"news_short_desc", label:"News-Short Description"},
    {value:"video_expandable", label:"Video Expandable"},
    {value:"video_endcard", label:"Video Endcard"},
    // {value:"video_skippable", label:"Video Skippable"},
    {value:'bottom_rectangle', label:"Bottom Rectangle"},
  ]
  const Classifieds = [  
  //{value:"square_classified",label:'Square Classified'},
    {value:"rectangle_classified", label:"Rectangle Classified"}]

  const FramePost = [
    {value:"framepost", label:"Frame Post"}
  ]
  const RecAds = [
    {value: "rec_image", label: "Recommended Image"},
    {value: "rec_promoted_story", label: "Recommended Promoted Story"},
  ]
  let c_value = [];

  if (selected === "image") {
    c_value = Image;
  } else if (selected === "video") {
    c_value = Video;
  } else if (selected === "promotedStory") {
    c_value = PromotedStory;
  } else if (selected === "animation") {
    c_value = Animation;
  }
  else if(selected === "webviewad"){
    c_value = webview
  }
  else if(selected === "commentad"){
    c_value = commentads
  }
  else if(selected === "brandad"){
    c_value = BrandAds
  }
  else if(selected === "classifieds"){
    c_value = Classifieds
  }
  else if(selected === "framepost"){
    c_value = FramePost
  }
  else if(selected === "recad"){
    c_value = RecAds
  }

  useEffect(() => {
    subType === "full_image" ? setFullImage(true) : setFullImage(false);
    subType === "promoted_video_story"
      ? setPromotedVideo(true)
      : setPromotedVideo(false);
    subType === "promoted_image_story"
      ? setPromotedImage(true)
      : setPromotedImage(false);
    subType === "promoted_gallery"
      ? setPromotedGallery(true)
      : setPromotedGallery(false);
    subType === "full_video" ? setFullvideo(true) : setFullvideo(false);
    subType === "half_video" ? setHalfvideo(true) : setHalfvideo(false);
    subType === "video_with_bg" ? setVideowithbg(true) : setVideowithbg(false);
    subType === "fullvideo_or_gif" ? setAnimation(true) : setAnimation(false);
    subType === "gallery" ? setGalleryImage(true) : setGalleryImage(false);
    subType === "webviewad" ? setWebviewad(true):setWebviewad(false);
    subType === "commentad" ? setCommentad(true):setCommentad(false);
    (subType === "search" || subType === "unread") ? setBrandAdImage(true) : setBrandAdImage(false);
    (subType === "news_image_flip" ) ? setNewsImageFlip(true) : setNewsImageFlip(false);
    (subType === "news_image_logo" ) ? setNewsImageLogo(true) : setNewsImageLogo(false);
    (subType === "news_short_desc" ) ? setNewsShortDesc(true) : setNewsShortDesc(false);
    (subType === "video_expandable" ? setVideoExpandable(true) : setVideoExpandable(false));
    (subType === "video_endcard" ? setVideoEndcard(true) : setVideoEndcard(false));
    (subType === "video_skippable" ? setVideoSkippable(true) : setVideoSkippable(false));
    (subType === "bottom_rectangle" ? setBottomRectangle(true) : setBottomRectangle(false));
    (subType === "square_classified" ? setSquare(true) : setSquare(false));
    (subType === "rectangle_classified" ? setRectangle(true) : setRectangle(false));
    (subType === "framepost" ? setFramePost(true) : setFramePost(false));
    (subType === "rec_image" ? setRecImages(true) : setRecImages(false));
    (subType === "rec_promoted_story" ? setRecPromotedStory(true) : setRecPromotedStory(false));
  }, [subType]);;
  function handleRequestClose(event) {
    if (event.detail.source === 'overlay') {
      event.preventDefault();
    }
  }

  useEffect(() => {
    if(editdata.name){
      setName(editdata.name)
    }
  }, [editdata])
  // console.log(editdata,"------editdata")
  return (
    <>
      <SlDrawer label="Preview" open={show}
      onSlAfterHide={handleModalClose}
      onSlRequestClose={handleRequestClose}
      style={{ '--size': 'fit-content' }}
      >
        <div className="row">
          <CreativeContext.Provider value={{ preview, setPreview }}>
            <section className="col-6">
              <fieldset className="form-fieldset">
                <legend className="">Details</legend>
                <section>
                  <div className="mb-3">
                    <label htmlFor="" className="form-label">
                      Company Name
                    </label>
                    <Select
                      // class="form-select"
                      placeholder={flag === "edit" ? editdata.company_name : "Select Company Name"}
                      isDisabled={flag==="edit"}
                      // inputValue={editdata.company_name}
                      onChange={handleCompanyname}
                      options={companyName}
                    ></Select>
                    {submit && company === "" && (
                      <p className="text-red-600">Select Company</p>
                    )}
                  </div>
                  {/* <div className="mb-3">
                    <label htmlFor="" className="form-label">
                      Advertiser Name
                    </label>
                    <Select
                      aria-label="Default select example"
                      placeholder={flag === "edit" ? editdata.advertiser_name :"Select Advertiser"}
                      isDisabled={flag === "edit"}
                      onChange={handleAdvertiser}
                      options={advertiser}
                    ></Select>
                    {submit && advId === "" && (
                      <p className="text-red-600">Select an Advertiser</p>
                    )}
                  </div> */}
                  <div className="mb-3">
                    <label htmlFor="" className="form-label">
                      Creative Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={flag==="edit"?editdata.name:"Enter Creative Name"}
                      // disabled={flag==="edit"}
                      value={name}
                      aria-label=""
                      onChange={handleCreativeName}
                    />
                    {submit && name === "" && (
                      <p className="text-red-600">Creative Name is required and cannot start with special characters</p>
                    )}
                  </div>

                  <div className="row mb-3">
                    <div className="col">
                      <label htmlFor="" className="form-label">
                        Creative Type
                      </label>
                      <Select
                        placeholder={flag==="edit"?editdata.creative_type: "select"}
                        isDisabled={flag==="edit"}
                        // inputValue={creativetype[editdata.creative_type]}
                        defaultValue={selected}
                        options={creativeType}
                        onChange={changeSelectOptionHandler}
                      ></Select>
                    </div>
                    <div className="col">
                      <label htmlFor="" className="form-label">
                        {" "}
                        Sub Type
                      </label>
                      <Select
                       placeholder={flag==="edit"?editdata.sub_type: "select"}
                       isDisabled={flag==="edit"}
                        // inputValue={subtype[editdata.sub_type]}
                        key={`myuniquekey${selected}`}
                        defaultValue={subType || ""}
                        options={c_value}
                        onChange={changeSubTypeHandler}
                      ></Select>

                      <div></div>
                    </div>
                  </div>
                </section>
              </fieldset>
              <fieldset className="form-fieldset">
                <legend>Upload</legend>

                {fullImage && (
                  <FullImage
                    company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    handleshow={handleshow}
                    flag={flag}
                    handlesubmit={handlesubmit}
                    setPreview={setPreview}
                    createdEdited={createdEdited}
                  />
                )}
                  {webviewad && (
                  <WebViewAd
                    company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    handleshow={handleshow}
                    flag={flag}
                    handlesubmit={handlesubmit}
                    setPreview={setPreview}
                    createdEdited={createdEdited}
                  />
                )}
                 {commentad && (
                  <CommentAd
                    company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    handleshow={handleshow}
                    flag={flag}
                    handlesubmit={handlesubmit}
                    setPreview={setPreview}
                    createdEdited={createdEdited}
                  />
                )}
                {promotedImage && (
                  <PromotedImage
                    company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}
                  />
                )}
                {promotedVideo && (
                  <PromotedVideo
                    company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}
                  />
                )}
                {fullvideo && (
                  <FullVideo
                    company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}
                  />
                )}
                {halfvideo && (
                  <HalfVideo
                    company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}
                  />
                )}
                {videowithbg && (
                  <VideowithBg
                    company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}
                  />
                )}
                {animation && (
                  <AnimationComponent
                    company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}
                  />
                )}
                {galleryImage && (
                  <GalleryImage
                    company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}
                  />
                )}
                {promotedgallery && (
                  <PromotedGallery
                    company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}
                  />
                )}
                {
                  brandAdImage && (
                    <BrandAdImage 
                    company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}
                    />
                  )
                }
                {
                  newsImageFlip && (
                    <NewsImage company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited} />
                  )
                }
                {
                  newsImageLogo && (
                    <NewsImageLogo company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited} />
                  )
                }
                {
                  newsShortDesc && (
                    <NewsImageDesc company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited} />
                  )
                }
                {
                  videoExpandable && (
                    <VideoExpandable company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited} />
                  )
                }
                {
                  videoEndcard && (
                    <VideoEndcard company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}/>
                  )
                }
                {
                  videoSkippable && ( 
                    <VideoSkippable company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}/>
                  )
                }
                {
                  bottomRectangle && (
                    <BottomRectangle company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}/>
                  )
                }
                {
                  rectangle && (
                    <RectangleClassified company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}/>
                  )
                }
                {
                  square && (
                    <SquareClassified company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}/>
                  )
                }
                {
                  framePost && (
                    <FramePostComponent company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}/>
                  )
                }
                {
                  recImages && (
                    <RecImage company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}/>
                  )
                }
                {
                  recPromotedStory && (
                    <RecPromoted company={company}
                    companyName={companyLabel}
                    // advId={advId}
                    creative_name={name}
                    creative_type={selected}
                    subtype={subType}
                    editdata={editdata}
                    flag={flag}
                    handleshow={handleshow}
                    handlesubmit={handlesubmit}
                    createdEdited={createdEdited}/>
                  )
                }
              </fieldset>
            </section>
            <section className="col-6">
              <PreviewFrame showPreview={true}></PreviewFrame>
            </section>
          </CreativeContext.Provider>
        </div>
      </SlDrawer>
    </>
    // <Modal
    //   show={show}
    //   onHide={handleModalClose}
    //   dialogClassName="modal-fullscreen"
    //   contentClassName="modal-height"
    // >
    //   <Modal.Header closeButton>
    //     <Modal.Title>Creative Creation</Modal.Title>
    //   </Modal.Header>
    //   <Modal.Body>
    //     <div className="row">
    //       <CreativeContext.Provider value={{ preview, setPreview }}>
    //         <section className="col-8">
    //           <fieldset className="form-fieldset">
    //             <legend className="">Details</legend>

    //             <section>

    //               <div className="mb-3">
    //                 <label htmlFor="" className="form-label">
    //                   Company Name
    //                 </label>
    //                 <Select
    //                   // class="form-select"
    //                   placeholder="Select Company Name"
    //                   inputValue={editdata.company_name}
    //                   onChange={handleCompanyname}
    //                   options={companyName}
    //                 ></Select>
    //                 {submit && company === "" && (
    //                   <p className="text-red-600">Select Company</p>
    //                 )}
    //               </div>


    //               <div className="mb-3">
    //                 <label htmlFor="" className="form-label">
    //                   Advertiser Name
    //                 </label>
    //                 <Select
    //                   // class="form-select"
    //                   aria-label="Default select example"
    //                   placeholder="Select Advertiser"
    //                   inputValue={editdata.advertiser_name}
    //                   onChange={handleAdvertiser}
    //                   options={advertiser}
    //                 ></Select>
    //                 {submit && advId === "" && (
    //                   <p className="text-red-600">Select an Advertiser</p>
    //                 )}
    //               </div>
    //               <div className="mb-3">
    //                 <label htmlFor="" className="form-label">
    //                   Creative Name
    //                 </label>
    //                 <input
    //                   type="text"
    //                   className="form-control"
    //                   placeholder="Enter Creative Name"
    //                   value={editdata.name}
    //                   aria-label=""
    //                   onChange={handleCreativeName}
    //                 />
    //                 {submit && name === "" && (
    //                   <p className="text-red-600">Enter Creative Name</p>
    //                 )}
    //               </div>

    //               <div className="row mb-3">
    //                 <div className="col">
    //                   <label htmlFor="" className="form-label">
    //                     Creative Type
    //                   </label>
    //                   <Select
    //                     inputValue={creativetype[editdata.creative_type]}
    //                     defaultValue={selected}
    //                     options={creativeType}
    //                     onChange={changeSelectOptionHandler}
    //                   ></Select>
    //                 </div>
    //                 <div className="col">
    //                   <label htmlFor="" className="form-label">
    //                     {" "}
    //                     Sub Type
    //                   </label>
    //                   <Select
    //                     inputValue={subtype[editdata.sub_type]}
    //                     key={`myuniquekey${selected}`}
    //                     defaultValue={subType || ""}
    //                     options={c_value}
    //                     onChange={changeSubTypeHandler}
    //                   ></Select>

    //                   <div></div>
    //                 </div>
    //               </div>
    //             </section>
    //           </fieldset>
    //           <fieldset className="form-fieldset">
    //             <legend>Upload</legend>

    //             {fullImage && (
    //               <FullImage
    //                 company={company}
    //                 advId={advId}
    //                 creative_name={name}
    //                 creative_type={selected}
    //                 subtype={subType}
    //                 editdata={editdata}
    //                 handleshow={handleshow}
    //                 flag={flag}
    //                 handlesubmit={handlesubmit}
    //                 setPreview={setPreview}
    //                 createdEdited={createdEdited}
    //               />
    //             )}
    //             {promotedImage && (
    //               <PromotedImage
    //                 company={company}
    //                 advId={advId}
    //                 creative_name={name}
    //                 creative_type={selected}
    //                 subtype={subType}
    //                 editdata={editdata}
    //                 flag={flag}
    //                 handleshow={handleshow}
    //                 handlesubmit={handlesubmit}
    //                 createdEdited={createdEdited}
    //               />
    //             )}
    //             {promotedVideo && (
    //               <PromotedVideo
    //                 company={company}
    //                 advId={advId}
    //                 creative_name={name}
    //                 creative_type={selected}
    //                 subtype={subType}
    //                 editdata={editdata}
    //                 flag={flag}
    //                 handleshow={handleshow}
    //                 handlesubmit={handlesubmit}
    //                 createdEdited={createdEdited}
    //               />
    //             )}
    //             {fullvideo && (
    //               <FullVideo
    //                 company={company}
    //                 advId={advId}
    //                 creative_name={name}
    //                 creative_type={selected}
    //                 subtype={subType}
    //                 editdata={editdata}
    //                 flag={flag}
    //                 handleshow={handleshow}
    //                 handlesubmit={handlesubmit}
    //                 createdEdited={createdEdited}
    //               />
    //             )}
    //             {halfvideo && (
    //               <HalfVideo
    //                 company={company}
    //                 advId={advId}
    //                 creative_name={name}
    //                 creative_type={selected}
    //                 subtype={subType}
    //                 editdata={editdata}
    //                 flag={flag}
    //                 handleshow={handleshow}
    //                 handlesubmit={handlesubmit}
    //                 createdEdited={createdEdited}
    //               />
    //             )}
    //             {videowithbg && (
    //               <VideowithBg
    //                 company={company}
    //                 advId={advId}
    //                 creative_name={name}
    //                 creative_type={selected}
    //                 subtype={subType}
    //                 editdata={editdata}
    //                 flag={flag}
    //                 handleshow={handleshow}
    //                 handlesubmit={handlesubmit}
    //                 createdEdited={createdEdited}
    //               />
    //             )}
    //             {animation && (
    //               <AnimationComponent
    //                 company={company}
    //                 advId={advId}
    //                 creative_name={name}
    //                 creative_type={selected}
    //                 subtype={subType}
    //                 editdata={editdata}
    //                 flag={flag}
    //                 handleshow={handleshow}
    //                 handlesubmit={handlesubmit}
    //                 createdEdited={createdEdited}
    //               />
    //             )}
    //             {galleryImage && (
    //               <GalleryImage
    //                 company={company}
    //                 advId={advId}
    //                 creative_name={name}
    //                 creative_type={selected}
    //                 subtype={subType}
    //                 editdata={editdata}
    //                 flag={flag}
    //                 handleshow={handleshow}
    //                 handlesubmit={handlesubmit}
    //                 createdEdited={createdEdited}
    //               />
    //             )}
    //             {promotedgallery && (
    //               <PromotedGallery
    //                 company={company}
    //                 advId={advId}
    //                 creative_name={name}
    //                 creative_type={selected}
    //                 subtype={subType}
    //                 editdata={editdata}
    //                 flag={flag}
    //                 handleshow={handleshow}
    //                 handlesubmit={handlesubmit}
    //                 createdEdited={createdEdited}
    //               />
    //             )}
    //           </fieldset>
    //         </section>
    //         <section className="col-4">
    //           <PreviewFrame></PreviewFrame>
    //         </section>
    //       </CreativeContext.Provider>
    //     </div>
    //   </Modal.Body>
    // </Modal>
  );
}

export default CreativeCreation;
